import { render, staticRenderFns } from "./subjects.vue?vue&type=template&id=4a3dc29a&scoped=true&"
import script from "./subjects.vue?vue&type=script&lang=js&"
export * from "./subjects.vue?vue&type=script&lang=js&"
import style0 from "./subjects.vue?vue&type=style&index=0&id=4a3dc29a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3dc29a",
  null
  
)

export default component.exports